import React from 'react';
import StatusPropertyPanel from './StatusPropertyPanel';
import TransitionPropertyPanel from './TransitionPropertyPanel';
import type { PlaybookStatusFull, PlaybookTransitionFull } from '../../types/playbook.types';

interface SidebarPropertyPanelProps {
  selectedStatus: PlaybookStatusFull | null;
  selectedTransition: PlaybookTransitionFull | null;
  statuses: PlaybookStatusFull[];
  onUpdateStatus: (statusId: string, data: Partial<PlaybookStatusFull>) => Promise<void>;
  onDeleteStatus: (statusId: string) => Promise<void>;
  onUpdateTransition: (transitionId: string, data: Partial<PlaybookTransitionFull>) => Promise<void>;
  onDeleteTransition: (transitionId: string) => Promise<void>;
  onRefresh: () => void;
}

const SidebarPropertyPanel: React.FC<SidebarPropertyPanelProps> = ({
  selectedStatus,
  selectedTransition,
  statuses,
  onUpdateStatus,
  onDeleteStatus,
  onUpdateTransition,
  onDeleteTransition,
  onRefresh,
}) => {
  if (!selectedStatus && !selectedTransition) {
    return (
      <div className="flex items-center justify-center h-full p-4">
        <p className="text-xs text-gray-400 dark:text-gray-500 text-center">
          Select a status node or transition edge to edit its properties
        </p>
      </div>
    );
  }

  if (selectedStatus) {
    return (
      <StatusPropertyPanel
        status={selectedStatus}
        onUpdate={onUpdateStatus}
        onDelete={onDeleteStatus}
      />
    );
  }

  if (selectedTransition) {
    return (
      <TransitionPropertyPanel
        transition={selectedTransition}
        statuses={statuses}
        onUpdate={onUpdateTransition}
        onDelete={onDeleteTransition}
        onRefresh={onRefresh}
      />
    );
  }

  return null;
};

export default SidebarPropertyPanel;
